/**
 * @class Configuration Handle widget configuration
 */
class Configuration {
    /**
     * @property {string} apiEndpoint
     */
    apiEndpoint = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "http://middleware.local/api/v1";

    /**
     * @property {string} country
     */
    country;

    /**
     * @property {string} language
     */
    language;

    /**
     * @property {string} brand
     */
    brand;

    /**
     * @property {string} vehicleUse
     */
    vehicleUse;

    /**
     * @property {string} derivedmodel If provided, initialize the widget with
     *                          data extracted from this string.
     */
    derivedmodel;

    /**
     * @property {int} disableCache Enable/Disable the cache on vehicle data
     */
    disableCache;

    /**
     * @property {string} triggerElementRef A ref to the element which trigger the
     *                                      widget opening.
     */
    triggerElementRef;

    /**
     * Validate the widget configuration
     * 
     * @throws Error if the configuration is wrong
     */
    validate = () => {
        // Check required properties
        [
            'apiEndpoint',
            'country',
            'language',
            'brand',
            'vehicleUse',
            'triggerElementRef',
        ]
        .forEach(property => {
            if (!this[property]) {
                throw new Error(`The parameter "${property}" is missing.`);
            }
        });
    }
}

export default new Configuration();


// WEBPACK FOOTER //
// ./src/Configuration.js